const pricing = {
  Long: {
    fromPricePerDay: "£1.99",
    fromLessThanPricePerDay: "£2.00",
    fromPricePerTrial: "£19.00",
  },
  Short: {
    fromPricePerDay: "£1.99",
    fromLessThanPricePerDay: "£2",
    fromPricePerTrial: "£19",
  },
} as const;

export default pricing;
